import { createAction } from "@reduxjs/toolkit";
import { SolidityContractDetails } from "~/api/data-schema/SolidityContractDetails";

export const loadDeployedContractsList = createAction(
    "MINTING/SOLIDITY_CONTRACTS/LOAD_DEPLOYED_CONTRACTS_LIST",
);
export const loadDeployedContractsListResponse = createAction<
    SolidityContractDetails[]
>("MINTING/SOLIDITY_CONTRACTS/LOAD_DEPLOYED_CONTRACTS_LIST_RESPONSE");
